import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitsFetchFailedAction = {
	type: 'AI_COST_LIMITS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitsFetchFailedAction => ({
	type: 'AI_COST_LIMITS_FETCH_FAILED',
	payload,
});
